import {
  Q_AND_A_ROLES,
  QAndARoles,
  QuestionStatus,
} from 'router/subrouters/DataRoom/models/QAndA';
import { ObjectValues } from 'types';
import {
  isQuestionAnswerApproved,
  isQuestionAnswered,
  isQuestionAnswerRejected,
  isQuestionApproved,
  isQuestionSellAsigned,
} from 'router/subrouters/DataRoom/utils';

export const MANAGE_ACTIONS_KEYS = {
  IN_REVIEW: 'inReview',
  NEEDS_ANSWER: 'needsAns',
  NEEDS_APPROVAL: 'needsApproval',
  PUBLISHED: 'published',
} as const;

export type ManageActionKeys = ObjectValues<typeof MANAGE_ACTIONS_KEYS>;

export const generateActionKey = (
  question: QuestionStatus,
): ManageActionKeys => {
  if (isQuestionApproved(question)) return MANAGE_ACTIONS_KEYS.IN_REVIEW;
  if (isQuestionAnswerRejected(question) || isQuestionSellAsigned(question))
    return MANAGE_ACTIONS_KEYS.NEEDS_ANSWER;
  if (isQuestionAnswered(question)) return MANAGE_ACTIONS_KEYS.NEEDS_APPROVAL;
  if (isQuestionAnswerApproved(question)) return MANAGE_ACTIONS_KEYS.PUBLISHED;
};

export const APPROVE_ROLES_ALLOWED_TO_ACTION: Record<
  ManageActionKeys,
  Array<QAndARoles>
> = {
  inReview: [
    Q_AND_A_ROLES.OWNER,
    Q_AND_A_ROLES.ADMIN_SELL,
    Q_AND_A_ROLES.COORDINATOR,
  ],
  needsAns: [
    Q_AND_A_ROLES.OWNER,
    Q_AND_A_ROLES.ADMIN_SELL,
    Q_AND_A_ROLES.EXPERT,
  ],
  needsApproval: [
    Q_AND_A_ROLES.OWNER,
    Q_AND_A_ROLES.ADMIN_SELL,
    Q_AND_A_ROLES.ANSWER_APPROVER,
    Q_AND_A_ROLES.COORDINATOR,
  ],
  published: [
    Q_AND_A_ROLES.OWNER,
    Q_AND_A_ROLES.ADMIN_SELL,
    Q_AND_A_ROLES.ANSWER_APPROVER,
  ],
};
